<div class="container-fluid mt-header fondo">
    <div class="row">
        <div class="col-12">
            <div class="container mt-header">
                <div class="row">
                    <div class="col-12">
                        <mat-tab-group mat-align-tabs="start">
                            <mat-tab class="border-tab" label="Persona física">
                                <app-formulario active="0"></app-formulario>
                            </mat-tab>
                            <mat-tab label="Persona moral">
                                <app-formulario active="1"></app-formulario>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

